import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var AddressBookIcon = function AddressBookIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.5h15A1.5 1.5 0 0 1 21 3v18a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 21V3a1.5 1.5 0 0 1 1.5-1.5zm0 1.5v18h15V3h-15zm7.5 9.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5zm0-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zM6.75 19.5a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .334-.624C7.961 14.041 9.856 13.5 12 13.5c2.144 0 4.04.541 5.666 1.626a.75.75 0 0 1 .334.624v3a.75.75 0 0 1-.75.75H6.75zM16.5 18v-1.837C15.202 15.388 13.707 15 12 15c-1.707 0-3.202.388-4.5 1.163V18h9z"
  }));
};

AddressBookIcon.displayName = 'AddressBookIcon';
export default AddressBookIcon;